import { createSlice } from '@reduxjs/toolkit';
import { isAlphabet, isInteger } from '../regexFuncs';

export const reserveBoxSlice = createSlice({
  name: 'reserveBox',
  initialState: {
    reserveName: '',
    emailId: '',
    phone: '',
    boxName: '',
    payment: '',
  },
  reducers: {
    updateReserveBoxForm: (state, action) => {
      const { name, value } = action.payload;
      switch (name) {
        case 'reserveName':
          if (value === '' || (isAlphabet(value) && value.length <= 33)) {
            return { ...state, [name]: value };
          }
          return { ...state };

        case 'emailId':
          return { ...state, [name]: value.trim() };

        case 'phone':
          if (value === '' || (isInteger(value) && value.length <= 10)) {
            return { ...state, [name]: value };
          }
          return { ...state };

        default:
          return { ...state };
      }
    },
    clearForm: () => {
      return {
        reserveName: '',
        emailId: '',
        phone: '',
        boxName: '',
        payment: '',
      };
    },
  },
});

export const { updateReserveBoxForm, clearForm } = reserveBoxSlice.actions;

export default reserveBoxSlice.reducer;
